import {
  ArgentinaBandera,
  BoliviaBandera,
  BrasilBandera,
  ChileBandera,
  ColombianaBandera,
  CoreaBandera,
  EcuadorBandera,
  EspanaBandera,
  FranciaBandera,
  MexicoBandera,
} from "../images";

export const conventionInternational = [
  {
    title: "Brasil",
    image: BrasilBandera,
    benefits: [
      "Beneficios: Cuenta con club militar y hoteles del Ejército de Brasil dirigido a todo el personal militar, previa coordinación con el Agregado Militar.",
      "Teléfono cel (ws) : <a target='_blank' href='https://api.whatsapp.com/send/?phone=966005004'>966005004</a>",
      "Teléfono  fijo: <a target='_blank' href='tel:00556132445534'>00556132445534</a>",
    ],
  },
  {
    title: "Argentina",
    image: ArgentinaBandera,
    benefits: [
      "Beneficios: Cuenta con alojamiento en hoteles administrados por el Círculo Militar y el uso de sus respectivas instalaciones, brindado a todo el personal militar en actividad y/o retiro, previa coordinación mediante el Agregado Militar.",
      "Teléfono cel (ws): <a target='_blank' href='https://api.whatsapp.com/send/?phone=51949430983'>51949430983</a> ",
      "Teléfono cel (ws): <a target='_blank' href='https://api.whatsapp.com/send/?phone=5491139299794'>5491139299794</a> ",
    ],
  },
  {
    title: "Chile",
    image: ChileBandera,
    benefits: [
      "Beneficios: Cuenta con todos los centros del sistema de bienestar, Círculos militares con hospedaje tarifas preferenciales, es necesario comunicar con la debida anticipación a fin de realizar coordinaciones y reservas, este beneficio está dirigido a todo el personal militar en situación de actividad y/o retiro y familiares.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=56985002700' target='_blank'>56985002700</a>",
      "Teléfono fijo: <a href='tel:0056323695567' target='_blank'>0056323695567</a>",
    ],
  },
  {
    title: "Corea",
    image: CoreaBandera,
    benefits: [
      "Beneficios: Dispone de hoteles, que brindan facilidades al personal militar en actividad de países extranjeros, que se encuentran de visita, previa coordinación con el Agregado Militar.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=821056508802' target='_blank' >821056508802</a>",
      "Teléfono fijo: <a href='tel:008207074531947' target='_blank'>008207074531947</a>",
    ],
  },
  {
    title: "Francia",
    image: FranciaBandera,
    benefits: [
      "Beneficios: Cuenta con hotel, alojamientos y/o similares, dirigido a todo el personal militar en actividad, retiro y familiares directos, coordinaciones de información y reserva se pueden realizar de manera directa en la página web www.igesa.fr.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=33624472745' target='_blank' >33624472745</a>",
    ],
  },
  {
    title: "Colombia",
    image: ColombianaBandera,
    benefits: [
      "Beneficios: Convenio suscrito con el círculo militar de las fuerzas militares de Colombia para el acceso a las instalaciones accediendo a tarifas preferenciales, este beneficio es para el personal militar en actividad y/o retiro y familiares, previa coordinación con la agregaduría militar.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=999950784' target='_blank' >999950784</a> ",
    ],
  },
  {
    title: "México",
    image: MexicoBandera,
    benefits: [
      "Beneficios: Alojamiento en el “Hotel Bicentenario” en beneficio para el personal de Oficiales, Supervisores, Técnicos, Sub Oficiales y familiares extranjeros, previa comunicación y con la debida anticipación para realizar la reserva correspondiente.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=966270981' target='_blank' >966 270 981</a>  ",
    ],
  },
  {
    title: "España",
    image: EspanaBandera,
    benefits: [
      "Beneficios: Se cuenta con diferentes Residencias Militares de Descanso (RMD), las cuales pueden ser utilizadas por todo el personal militar y familia, previo trámite y gestión de solicitud, en coordinación con el Agregado Militar.",
      "Teléfono cel (ws): <a href='https://api.whatsapp.com/send/?phone=34629228505' target='_blank' >34629228505</a> ",
    ],
  },
  {
    title: "Ecuador",
    image: EcuadorBandera,
    benefits: ["Estamos trabajando por el bienestar", "Proximamente..."],
  },
  {
    title: "Bolivia",
    image: BoliviaBandera,
    benefits: ["Estamos trabajando por el bienestar", "Proximamente..."],
  },
];
